module.exports = function ($sce) {
    return function (text, phrase) {
        if (phrase) {
            text = text.replace(new RegExp(`(${phrase})`, 'gi'),
                '<span class="u-semibold">$1</span>');

            return $sce.trustAsHtml(text);
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/oly-highlight.js
 **/